import weightUpdate from "@/router/props/weight/update";
import BaseForm from "@/views/BaseForm.vue";
import Weight from "@/views/Weight/Weight.vue";
import { actionPrefix, modulesSystem, modulesSystemLevel } from "@/constants";

export default [
  {
    path: "/weight",
    name: "weight",
    meta: {
      ShowNav: true,
      title: "Pesos",
      modulesNeeded: [modulesSystem.weights, modulesSystemLevel.read],
      navBarTab: 9,
    },
    component: Weight,
    props: weightUpdate,
  },
];
